import {
  createIAPComponentModule,
  IAPComponentModuleHooks,
} from '@play-co/components';
import { options } from './iap.options';
import createHooks from '../../config/components/createHooks';
import { fulfillPurchaseV2 } from '../iap.modifiers';

/**
 * Hooks for IAP component
 */
const hooks = createHooks<IAPComponentModuleHooks<typeof options>>()({
  /**
   * On purchase success callback
   */
  onPurchaseSuccess: (state, { productId, payment }, api) => {
    fulfillPurchaseV2(
      state,
      {
        productId,
        productPrice: payment.price,
        purchaseId: payment.purchaseId,
      },
      api,
      { sendPurchaseConfirmation: !options.enableCheats },
    );
  },
});

// Export the replicant module
export const iapComponentModule = createIAPComponentModule(options, hooks);
